import axios from "axios";
import i18next from "i18next";
import LogIn from "./API/LogIn";

//Construct the methods
const NetworkingOperations = {
	get: ({ url, headers, ...options }) =>
		instance({
			method: "get",
			url,
			headers: {
				"Content-Type": "application/json",
				"Content-Language": i18next.language,
				...headers,
			},
			data: null,
			...options,
		})
			.then((res) => res)
			.catch((error) => {
				throw error.response.data;
			}),
	post: ({ url, headers, ...options }) =>
		instance({
			method: "post",
			url,
			headers: {
				"Content-Type": "application/json",
				"Content-Language": i18next.language,
				...headers,
			},
			data: null,
			...options,
		})
			.then((res) => res)
			.catch((error) => {
				throw error.response.data;
			}),
	put: ({ url, headers, ...options }) =>
		instance({
			method: "put",
			url,
			headers: {
				"Content-Type": "application/json",
				"Content-Language": i18next.language,
				...headers,
			},
			data: null,
			...options,
		})
			.then((res) => res)
			.catch((error) => {
				throw error.response.data;
			}),
	delete: ({ url, headers, ...options }) =>
		instance({
			method: "delete",
			url,
			headers: {
				"Content-Type": "application/json",
				"Content-Language": i18next.language,
				...headers,
			},
			data: null,
			...options,
		})
			.then((res) => res)
			.catch((error) => {
				throw error.response.data;
			}),
};

NetworkingOperations.defaultProps = {
	method: "get",
	url: "/user/12345",
	data: {},
};

// Create instance
let instance = axios.create(NetworkingOperations.defaultProps);

// Set the AUTH token for any request
instance.interceptors.request.use(function (config) {
	const token = sessionStorage.getItem("token");
	config.headers.Authorization = token ? `${token}` : "";
	return config;
});

instance.interceptors.response.use(
	(res) => {
		return res;
	},
	async (err) => {
		const originalConfig = err.config;

		// Access Token was expired
		if (err.response.status === 401 && err.response.data.code === 99) {
			originalConfig._retry = true;

			try {
				const rs = await LogIn();

				sessionStorage.setItem("token", rs.data.token);

				return instance(originalConfig);
			} catch (_error) {
				return Promise.reject(_error);
			}
		}

		return Promise.reject(err);
	},
);

export default NetworkingOperations;
